// - PNG Images
import logo from "../assets/images/png/logo.png";
import DashboardLogo from "../assets/images/png/DashboardLogo.png";
import login_background_img from "../assets/images/png/login_background_img.png";
import topics_empty_img from "../assets/images/png/topics_empty_img.png";
import ModuleCardOrangeBackground from "../assets/images/png/ModuleCardOrangeBackground.png";
import ModuleCardBlueBackground from "../assets/images/png/ModuleCardBlueBackground.png";
import ModuleCardPinkBackground from "../assets/images/png/ModuleCardPinkBackground.png";
import ModuleCardPurpleBackground from "../assets/images/png/ModuleCardPurpleBackground.png";
import ModuleCardGreenBackground from "../assets/images/png/ModuleCardGreenBackground.png";
import ModuleCardYellowBackground from "../assets/images/png/ModuleCardYellowBackground.png";
import xlspic from "../assets/images/png/Frame 730.png";
import pdfpic from "../assets/images/png/pdfpic.png";
import time_taken from "../assets/images/png/time_taken.png"
import incorrect from "../assets/images/png/incorrect.png"
import fileplus from "../assets/images/png/fileplus.png"
import correct from "../assets/images/png/correct.png"
import attempted from "../assets/images/png/attempted.png"
import timeicon from "../assets/images/png/timeicon.png"
import light_bulb from "../assets/images/png/light_bulb.png"
import reviewerpopup from "../assets/images/png/reviewerpopup.png"


// - SVG Images
import back_arrow_login from "../assets/images/svg/back_arrow_login.svg";
import camera from "../assets/images/svg/camera.svg";
import chapter_edit from "../assets/images/svg/chapter_edit.svg";
import circle_plus from "../assets/images/svg/circle_plus.svg";
import cross from "../assets/images/svg/cross.svg";
import edit from "../assets/images/svg/edit.svg";
import email from "../assets/images/svg/email.svg";
import exclamation_mark from "../assets/images/svg/exclamation_mark.svg";
import file from "../assets/images/svg/file.svg";
import left_arrow from "../assets/images/svg/left_arrow.svg";
import lock from "../assets/images/svg/lock.svg";
import menu_icon from "../assets/images/svg/menu_icon.svg";
import notification from "../assets/images/svg/notification.svg";
import password_hide from "../assets/images/svg/password_hide.svg";
import password_show from "../assets/images/svg/password_show.svg";
import plus from "../assets/images/svg/plus.svg";
import power from "../assets/images/svg/power.svg";
import profile_logout from "../assets/images/svg/profile_logout.svg";
import profile from "../assets/images/svg/profile.svg";
import right_arrow from "../assets/images/svg/right_arrow.svg";
import search from "../assets/images/svg/search.svg";
import select_file from "../assets/images/svg/select_file.svg";
import tick_mark from "../assets/images/svg/tick_mark.svg";
import topic_edit from "../assets/images/svg/topic_edit.svg";
import up_down_arrow from "../assets/images/svg/up_down_arrow.svg";
import user_profile from "../assets/images/svg/user_profile.svg";
import deleteIcon from "../assets/images/svg/deleteIcon.svg";
import StudyMaterialAddedSuccess from "../assets/images/svg/StudyMaterialAddedSuccess.svg";
import noTopics from "../assets/images/svg/noTopics.svg";
import buttonEndPattern from "../assets/images/svg/buttonEndPattern.svg";
import menu_icon_two from '../assets/images/svg/menu_icon_two.svg';
import addbutton from '../assets/images/svg/addbutton.svg'
import amount from "../assets/images/svg/amount.svg";
import balance from "../assets/images/svg/balance.svg"
import received from "../assets/images/svg/received.svg"
import coordinatorrupees from "../assets/images/svg/coordinatorrupees.svg"
import righticonmark from "../assets/images/svg/righticonmark.svg"
import magicalstar from "../assets/images/svg/magicalstar.svg"
import view from "../assets/images/svg/view.svg"
import resendCredentials from "../assets/images/svg/resendcredentials.svg"
import resetPassword from "../assets/images/svg/resetpassword.svg"
// - PNG Images Export
export const PngImages = {
  logo: logo,
  DashboardLogo: DashboardLogo,
  login_background_img: login_background_img,
  topics_empty_img: topics_empty_img,
  ModuleCardOrangeBackground: ModuleCardOrangeBackground,
  ModuleCardBlueBackground: ModuleCardBlueBackground,
  ModuleCardPinkBackground: ModuleCardPinkBackground,
  ModuleCardPurpleBackground: ModuleCardPurpleBackground,
  ModuleCardGreenBackground: ModuleCardGreenBackground,
  ModudleCardYellowBackground: ModuleCardYellowBackground,
  xlspic: xlspic,
  pdfpic: pdfpic,
  time_taken: time_taken,
  incorrect: incorrect,
  fileplus: fileplus,
  correct: correct,
  attempted: attempted,
  timeicon: timeicon,
  light_bulb: light_bulb,
  reviewerpopup, reviewerpopup,

};

// - SVG Images Export
export const SvgImages = {
  buttonEndPattern: buttonEndPattern,
  back_arrow_login: back_arrow_login,
  camera: camera,
  chapter_edit: chapter_edit,
  circle_plus: circle_plus,
  cross: cross,
  deleteIcon: deleteIcon,
  edit: edit,
  email: email,
  exclamation_mark: exclamation_mark,
  file: file,
  left_arrow: left_arrow,
  lock: lock,
  menu_icon: menu_icon,
  notification: notification,
  password_hide: password_hide,
  password_show: password_show,
  plus: plus,
  power: power,
  profile_logout: profile_logout,
  profile: profile,
  right_arrow: right_arrow,
  search: search,
  select_file: select_file,
  tick_mark: tick_mark,
  topic_edit: topic_edit,
  up_down_arrow: up_down_arrow,
  user_profile: user_profile,
  StudyMaterialAddedSuccess: StudyMaterialAddedSuccess,
  noTopics: noTopics,
  menu_icon_two: menu_icon_two,
  addbutton: addbutton,
  amount: amount,
  balance: balance,
  received: received,
  coordinatorrupees: coordinatorrupees,
  righticonmark: righticonmark,
  magicalstar,
  view,
  resendCredentials,
  resetPassword,
};
